import React from "react";

export const NEW_PROJECT = {
    id: -1,
    name: "Создать новый поток",
    icon:<i className="fa fa-plus-circle"/> };